import * as Yup from 'yup';

const regex = /\([0-9]{3}\) [0-9]{3}-[0-9]{4}/;

declare module 'yup' {
  export interface StringSchema {
    phone(errorMessage?: string): StringSchema;
  }
}
Yup.addMethod(Yup.string, 'phone', function validatePhone(errorMessage: string) {
  return this.test('phone', errorMessage, (value) => !value || regex.test(value));
});
